import React from 'react';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles['footer-content']}>
        <p className={styles['copyright-notice']}>
          © {currentYear} Sindhu Dokras. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
